import { render, staticRenderFns } from "./CustomFieldsInput.vue?vue&type=template&id=b60de442"
import script from "./CustomFieldsInput.vue?vue&type=script&lang=js"
export * from "./CustomFieldsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports